import CroppingTool from "./partials/CroppingTool";
import Picture from "./Picture";

Picture.CroppingTool = CroppingTool;

export default Picture;
